import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=b28bbaae&scoped=true&"
import script from "./snackbar.vue?vue&type=script&lang=js&"
export * from "./snackbar.vue?vue&type=script&lang=js&"
import style0 from "~/components/notificationSpace/snackbar.css?vue&type=style&index=0&id=b28bbaae&scoped=true&lang=css&"
import style1 from "~/components/notificationSpace/snackbar720.css?vue&type=style&index=1&id=b28bbaae&scoped=true&lang=css&"
import style2 from "./snackbar.vue?vue&type=style&index=2&id=b28bbaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28bbaae",
  null
  
)

export default component.exports